import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export enum StockLevels {
  inStock = "In stock",
  outOfStock = "Out of stock",
  lowStock = "Low stock",
  allocated = "This is an allocated item",
  noRecentUpdate = "No recent inventory update",
  notSoldAtThisLocation = "Not sold at this location",
  temporarilyUnavailable = "Inventory information temporarily unavailable",
}
export interface BuyingOption {
  label: string;
  quantity: number;
  quantity_type: "unit" | "case";
}

export interface Notice {
  level: "info" | "warning" | "error" | "success";
  message?: string;
}

export interface DistributorSummary {
  id: number;
  name: string;
  uses_warehouse_pickup: boolean;
  allow_ordering_out_of_stock: boolean;
  uses_wine_cellar: boolean;
  uses_happy_hour: boolean;
  fulfillment_model:
    | "delivery_only"
    | "pickup_only"
    | "pickup_and_delivery"
    | "delivery_and_single_pickup_location";
  requires_account_number: boolean;
  default_stock_site_id?: string | null;
  default_stock_site_name?: string | null;
  default_warehouse_id?: number | null;
}

export interface ProductSummary {
  id: number;
  product_line_id: number;
  container_case_size: number;
  full_sleeve_only: boolean;
}

export interface FulfillmentSummary {
  type: "delivery" | "pickup";
  id?: number;
  name?: string;
}

export interface MinimumOrderQuantity {
  label: string | null;
  units: number | null;
  cases: number | null;
  sleeves: number | null;
}

export interface CartItemResponse {
  inventory_id: number;
  sku: string;
  buying_options: BuyingOption[];
  notices: Notice[];
  quantity_restrictions?: {
    unit_limit: number | null;
    units_per_case: number | null;
    enforce: boolean;
    additional_action: "quantity_restrictions.request_item";
  };
  distributor_summary: DistributorSummary;
  product_summary: ProductSummary;
  mandate_list?: {
    additional_action:
      | "mandate_list.manage_request"
      | "mandate_list.request_item"
      | "mandate_list.view_request";
  };

  stock_info: StockInfo;
  sold_by: "cases_only" | "units_only" | "cases_and_units" | null;
  fulfillment_summary: FulfillmentSummary | null;
  has_hh_prices: boolean;
  minimum_order_quantity: MinimumOrderQuantity | null;
}

export interface StockInfo {
  additional_action?: string;
  level?: StockLevels;
  reason?: string;
  last_updated_at?: Date | null;
}

export interface CartProductUpdateParams {
  inventory_id: number;
  case_quantity: number;
  unit_quantity: number;
  warehouse_id?: number;
  requested_item?: boolean;
}

export const fetchCartWidgetItem = async (
  inventoryId: number,
  stockSiteId: string | null = null,
): Promise<CartItemResponse> => {
  let url = `/api/retailer/cart_widget_items/${inventoryId}`;
  if (stockSiteId) url += `?stock_site_id=${stockSiteId}`;
  return await HttpPromise({ method: "GET", url });
};

export const updateCartProductsForInventory = async (
  inventoryId: number,
  cartProduct: CartProductUpdateParams,
): Promise<CartItemResponse> => {
  const url = `/api/retailer/cart_widget_items/${inventoryId}/update_cart`;
  const data = { cart_product: cartProduct };
  return await HttpPromise({ method: "POST", url, data });
};
